import roles from './roles';

export default Object.freeze({
  HOME: {
    path: '/'
  },
  DASHBOARD: {
    path: '/dashboard'
  },
  GROUP_TRAININGS: {
    path: '/dashboard/trainings/group-trainings',
    roleIds: [roles.ADMIN.id, roles.MODERATOR.id, ]
  },
  PERSONAL_TRAININGS: {
    path: '/dashboard/trainings/personal-trainings',
    roleIds: [roles.ADMIN.id, roles.MODERATOR.id, roles.SUPERUSER.id]
  },
  USERS: {
    path: '/dashboard/users',
    roleIds: [roles.ADMIN.id, roles.MODERATOR.id]
  },
  USERS_RESERVATION: {
    path: '/dashboard/users-reservation',
    roleIds: [roles.ADMIN.id, roles.MODERATOR.id, roles.USER.id]
  },
  LOGIN: {
    path: '/login'
  },
  NOTFOUND: {
    path: '/404'
  },
  MODERATOR_USERS_STATISTICS: {
    path: '/dashboard/moderator-statistics',
    roleIds: [roles.ADMIN.id, roles.MODERATOR.id]
  },
  USER_STATISTICS: {
    path: '/dashboard/user-statistics',
    roleIds: [roles.ADMIN.id, roles.MODERATOR.id, roles.USER.id, roles.SUPERUSER.id]
  },
  CUSTOM_TRAININGS: {
    path: '/dashboard/custom-trainings',
    roleIds: [roles.ADMIN.id, roles.MODERATOR.id, roles.SUPERUSER.id]
  },
  WORKOUTS_MANAGEMENT: {
    path: '/dashboard/workouts',
    roleIds: [roles.ADMIN.id, roles.MODERATOR.id, roles.SUPERUSER.id]
  },
  TRAINING_SESSION: {
    path: '/dashboard/training-session',
    roleIds: [roles.ADMIN.id, roles.MODERATOR.id, roles.SUPERUSER.id, roles.USER.id]
  },
  TRAINING_SESSION_DETAILS: {
    path: '/dashboard/training-session/:id',
    roleIds: [roles.ADMIN.id, roles.MODERATOR.id, roles.SUPERUSER.id, roles.USER.id]
  },
  RELEASE_NOTES: {
    path: '/dashboard/release-notes',
    roleIds: [roles.ADMIN.id, roles.MODERATOR.id, roles.SUPERUSER.id, roles.USER.id]
  },
  ADMIN_RELEASE_NOTES: {
    path: '/dashboard/admin-release-notes',
    roleIds: [roles.ADMIN.id]
  },
  LOCATIONS_MANAGEMENT: {
    path: '/dashboard/locations-management',
    roleIds: [roles.ADMIN.id]
  },
  ADMIN_WORKOUTS_REVIEW: {
    path: '/dashboard/workouts-review',
    roleIds: [roles.ADMIN.id]
  }
});